import {TRANSLATION, Yup} from '@/imports-files/components/add-new-stage';

export const ADD_NEW_STAGE = {
	job_stage_label_attributes: {
		label: ''
	},
	interview_type_id: '',
  member_emails: [],
  member_initials: [],
	after_stage_id: '',
  stage_id: ''
}

export function addNewStageValidation(isScreening){
  return Yup.object({
    job_stage_label_attributes: Yup.object().shape({
                                label: Yup.string().required(TRANSLATION('errors:required')).nullable(true)
                              }),
    interview_type_id: Yup.string().when([], {
            is: () => !isScreening,
            then: Yup.string().required(TRANSLATION('errors:required')).nullable(true),
            otherwise: Yup.string().notRequired()
          }),
    member_emails: Yup.array(),
    after_stage_id: Yup.string().required(TRANSLATION('errors:required')).nullable(true),
    stage_id: Yup.string().required(TRANSLATION('errors:required')).nullable(true)
  })
}